import { render, staticRenderFns } from "./LogoutSuccess.vue?vue&type=template&id=28dfae09"
import script from "./LogoutSuccess.vue?vue&type=script&lang=js"
export * from "./LogoutSuccess.vue?vue&type=script&lang=js"
import style0 from "./LogoutSuccess.vue?vue&type=style&index=0&id=28dfae09&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports